import { render, staticRenderFns } from "./WorkingHouseBlCargoInfo.vue?vue&type=template&id=c8d28fd4&scoped=true"
import script from "./WorkingHouseBlCargoInfo.vue?vue&type=script&lang=js"
export * from "./WorkingHouseBlCargoInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkingHouseBlCargoInfo.vue?vue&type=style&index=0&id=c8d28fd4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d28fd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8d28fd4')) {
      api.createRecord('c8d28fd4', component.options)
    } else {
      api.reload('c8d28fd4', component.options)
    }
    module.hot.accept("./WorkingHouseBlCargoInfo.vue?vue&type=template&id=c8d28fd4&scoped=true", function () {
      api.rerender('c8d28fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingHouseBlCargoInfo.vue"
export default component.exports